import {
  ROAM_SCENE,
  SELECTED_HOTSPOT,
  OPEN_ARTICLE,
  OPEN_IFRAME,
} from '@/config/contant'

export default {
  data() {
    return {
      hotspotObj: null,
    }
  },
  mounted() {
    this.emitHotspotClick()
  },
  methods: {
    emitHotspotClick() {
      this.$vgo.on(SELECTED_HOTSPOT, obj => {
        this.hotspotObj = obj.data
        const data = JSON.parse(this.hotspotObj.datastr)
        if (obj.data.type_id === this.$CONFIG.videoHotspotId) {
          // 视频
          console.log(obj.data)
        }
        if (obj.data.type_id === this.$CONFIG.imageHotspotId) {
          // 图片
        }
        if (obj.data.type_id === this.$CONFIG.linkHotspotId) {
          // 连接
          if (data.typeData.blank) {
            window.open(data.typeData.link)
          } else {
            this.$vgo.emit(OPEN_IFRAME, data.typeData.link)
          }
        }
        if (obj.data.type_id === this.$CONFIG.articleHotspotId) {
          // 图文
          this.$vgo.emit(OPEN_ARTICLE, data.typeData.matId)
        }
        if (obj.data.type_id === this.$CONFIG.roamHotspotId) {
          // 场景漫游
          this.$vgo.emit(ROAM_SCENE, obj.data)
        }
      })
    },
  },
}
